// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"47b85d7e","290":"47b85d7e","301":"47b85d7e","306":"47b85d7e","436":"47b85d7e","759":"47b85d7e"}[chunkId] + ".chunk.css";
};